// Object.values Polyfill
if (!Object.values) {
  Object.values = function (obj) {
    if (obj !== Object(obj)) throw new TypeError('Object.values called on a non-object')
    var val = [],
      key
    for (key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        val.push(obj[key])
      }
    }
    return val
  }
}

// Object.entries Polyfill
if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i) // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]]
    return resArray
  }
}
